import { computed, observable } from "mobx";

class UrlsImpl {
	@observable ts: string;

	root: string;

	constructor() {
		this.reloadBranding();
	}

	home = "/";
	branding = "/branding";
	collections = "/collections";
	languages = "/languages";
	metas = "/metamanagement";
	portals = "/portals";
	reader = "/reader";
	search = "/search";
	sync = "/sync";
	userManagement = "/nacs/admin";
	userprofile = "/nacs/admin/user_profile";
	changepassword = "/nacs/admin/change_password";
	translation = "/translation";
	recentFiles = "/recentfiles";
	favorites = "/favorites";
	about = "/about";

	imprintUrl = "/imprint";
	legalnoticeUrl = "/legalnotice";
	privacypolicyUrl = "/privacypolicy";

	//authenticate = "/nacs/select?state=%2F&response_mode=form_post";
	//logout = "/nacs/logout?post_logout_redirect_uri=/";

	authenticate = "/authorize?redirect_uri=%2F&local_only=true&select_account=true";
	logout = "/endsession?redirect_uri=%2F&local_only=true";

	reloadBranding() {
		this.ts = new Date().getTime().toString();

		let css = document.getElementById("appcss") as HTMLLinkElement;
		css.href = css.href.replace(new RegExp("\\?.*"), "") + "?ts=" + this.ts;

		let ico = document.getElementById("appfavicon") as HTMLLinkElement;
		ico.href = ico.href.replace(new RegExp("\\?.*"), "") + "?ts=" + this.ts;
	}

	@computed get applicationLogo(): string {
		return "/branding/ApplicationLogo.png?ts=" + this.ts;
	}

	@computed get titleBarLogo(): string {
		return "/branding/TitleBarLogo.png?ts=" + this.ts;
	}

	@computed get applicationLead(): string {
		return "/branding/ApplicationLead.html?ts=" + this.ts;
	}

	@computed get imprint(): string {
		return "/branding/Imprint.html?ts=" + this.ts;
	}

	@computed get legalNotices(): string {
		return "/branding/LegalNotices.html?ts=" + this.ts;
	}

	@computed get privacyPolicy(): string {
		return "/branding/PrivacyPolicy.html?ts=" + this.ts;
	}

}

export var Urls = new UrlsImpl();